import styled from "styled-components";

export const OpenChatPubListWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 1000;
`;

export const OpenChatBackWrapper = styled.div`
  width: 80px;
  height: 30px;
  background: #fff;
  position: absolute;
  border-radius: 12px;
  top: -45px;
  left: 40%;
  translafe: transformX(-50%);
  z-index: 1000;
  font-weight: 700;
  font-size: 11px;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;

  > img {
    width: 18px;
    height: 18px;
  }
`;

export const OpenChatListWrapper = styled.div`
  background: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
  padding: 30px 16px 30px;
  box-sizing: border-box;

  > .header {
    display: flex;
    justify-content: space-between;

    > .title {
      font-weight: 800;
      font-size: 20px;
    }

    > .button {
      height: 30px;
      border-radius: 15px;
      font-weight: 600;
      font-size: 12px;
      line-height: 30px;
      text-align: center;
      padding: 0 12px;
      background: #f6de00;
    }
  }
`;

export const OpenChatList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
`;

export const OpenChatItemWrapper = styled.div`
  border-bottom: 1px solid var(--Black-100, #f0f0f0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  gap: 10px;

  > .pub-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;

    > .pub {
      font-weight: 700;
      font-size: 14px;
    }

    > .addr {
      font-weight: 400;
      font-size: 12px;
      color: var(--Black-300, #808080);
    }
  }

  > .button {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    background: var(--Purple-300, #6436e7);
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 30px;
    color: #fff;
  }
`;
